import * as cx from 'classnames';
import EnhancedTextarea, { PublicProps as EnhancedTextareaProps } from 'mk2/components/forms/EnhancedTextarea';
import FormControl from 'mk2/components/forms/FormControl';
import * as React from 'react';
import { Field, WrappedFieldProps } from 'redux-form';
import styles from './TextareaField.mscss';

// public properties exposed via forms/TextareaField
interface TextareaFormControlPublicProps {
    classNames?: {
        label?: string;
    };
    label?: string;
    bottomBorder?: boolean;
    marginLeft?: boolean;
    fillRemainingSpace?: boolean;  // expand to fill remaining horizontal space in form
}

type TextareaControlProps =  EnhancedTextareaProps & TextareaFormControlPublicProps & WrappedFieldProps;

const TextareaFormControl: React.StatelessComponent<TextareaControlProps> = ({
    input, meta, label,                                        // WrappedFieldProps
    classNames, bottomBorder, marginLeft, fillRemainingSpace,  // TextareaFormControlPublicProps
    ...etaInputProps                                           // EnhancedTextareaProps
}) => (
    <FormControl
        classNames={{
            label: cx(classNames && classNames.label,
                !etaInputProps.placeholder && styles.TextareaField__label),
        }}
        input={input}
        meta={meta}
        label={label}
        bottomBorder={bottomBorder}
        marginLeft={marginLeft}
        minimizedLabel={!!etaInputProps.placeholder}
        fillRemainingSpace={fillRemainingSpace}
    >
        <EnhancedTextarea
            input={input}
            hasLabel={!!label}
            {...etaInputProps}
        />
    </FormControl>
);

type TextareaFieldProps = EnhancedTextareaProps & TextareaFormControlPublicProps & {
    // see https://redux-form.com/7.3.0/docs/api/field.md/#props-you-can-pass-to-code-field-code-
    name: string;
};

const TextareaField: React.StatelessComponent<TextareaFieldProps> = (props) => (
    <Field {...props} component={TextareaFormControl} />
);

export default TextareaField;
